<template>
    <el-dialog
            :title="editForm.cartonsId?'编辑角色物品':'新增角色物品'"
            :visible.sync="dialogVisible"
            width="800px"
            append-to-body
            :close-on-click-modal="false"
            :before-close="handleClose">

        <el-form :model="editForm" :rules="editFormRules" ref="editForm" label-width="100px" class="demo-editForm">

            <el-form-item label="角色物品名称" prop="goodsName" label-width="120px">
                <el-input v-model="editForm.goodsName" autocomplete="off"></el-input>
            </el-form-item>
            <!-- <el-form-item label="商品原价" prop="cartonsGoodsOriginalPrice" label-width="120px">
                <el-input v-model="editForm.cartonsGoodsOriginalPrice" autocomplete="off" type="number"></el-input>
            </el-form-item> -->
            <el-form-item label="商品价格" prop="cartonsGoodsPrice" label-width="120px">
                <el-input v-model="editForm.cartonsGoodsPrice" autocomplete="off" type="number"></el-input>
            </el-form-item>
            <el-form-item label="商品定金"  label-width="120px" v-if="storeGoodsStatus==1">
                <el-input v-model="editForm.storeGoodsPresellPrice" autocomplete="off" type="number"></el-input>
            </el-form-item>
            <el-form-item label="总数" prop="totalCount" label-width="120px">
                <el-input :disabled="totalCountdisabled" v-model="editForm.totalCount" autocomplete="off" @input="change($event)" ></el-input>
            </el-form-item>
             <!-- <el-form-item label="69码" prop="sixtyNineCode" label-width="120px">
                <el-input v-model="editForm.sixtyNineCode" autocomplete="off"></el-input>
            </el-form-item> -->
            <el-form-item label="角色物品封面" prop="goodsCover" label-width="120px">
                <VploadImg :limit="1" v-bind:file-list="fileList" :type="1"   @submitImg="getImgList" ></VploadImg>
            </el-form-item>
            <el-form-item label="预售开始时间" prop="preSaleStartTime" label-width="120px" v-if="storeGoodsStatus==1">
                <el-date-picker
                        v-model="editForm.preSaleStartTime"
                        type="datetime"
                        default-time="00:00:00"
                        value-format="yyyy-MM-dd HH:mm:ss"
                        placeholder="选择预售开始时间">
                </el-date-picker>
            </el-form-item>
            <el-form-item label="预售截止时间" prop="preSaleEndTime" label-width="120px" v-if="storeGoodsStatus==1">
                <el-date-picker
                        v-model="editForm.preSaleEndTime"
                        type="datetime"
                        default-time="23:59:59"
                        value-format="yyyy-MM-dd HH:mm:ss"
                        placeholder="选择预售截止时间">
                </el-date-picker>
            </el-form-item>
            <el-form-item label="商品完成时间" prop="productCompletionTime" label-width="120px" v-if="storeGoodsStatus==1">
                <el-date-picker
                        v-model="editForm.productCompletionTime"
                        type="datetime"
                        default-time="23:59:59"
                        value-format="yyyy-MM-dd HH:mm:ss"
                        placeholder="选择商品完成时间">
                </el-date-picker>
            </el-form-item>
            <el-form-item label="到货时间" prop="arrivalTime" label-width="120px" v-if="storeGoodsStatus==1">
                <el-date-picker
                        v-model="editForm.arrivalTime"
                        type="datetime"
                        default-time="23:59:59"
                        value-format="yyyy-MM-dd HH:mm:ss"
                        placeholder="选择到货时间">
                </el-date-picker>
            </el-form-item>
            <el-form-item label="补款发货时间" prop="replenishmentDeliveryTime" label-width="120px" v-if="storeGoodsStatus==1">
                <el-date-picker
                        v-model="editForm.replenishmentDeliveryTime"
                        type="datetime"
                        default-time="23:59:59"
                        value-format="yyyy-MM-dd HH:mm:ss"
                        placeholder="选择补款发货时间">
                </el-date-picker>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="submitForm('editForm')">保存</el-button>
                <el-button @click="resetForm('editForm')">重置</el-button>
            </el-form-item>
        </el-form>

    </el-dialog>
</template>

<script>
    import VploadImg from "../../../inc/VploadImgTwo";
    export default {
        name: "CaseFrom",
        components:{
          VploadImg
        },
        props:{
            storeGoodsId:{
                type:Number,
            },
        },
        watch:{
            storeGoodsId(n,o){ //n为新值,o为旧值;
                this.storeGoodsId=n
            }
        },
        data(){
            return{
                editForm:{},
                storeGoodsStatus:0,
                dialogVisible:false,
                fileList:[],
                totalCountdisabled:false,
                parameterList:[],
                editFormRules: {
                    goodsName: [
                        {required: true, message: '请输入单品物品名称', trigger: 'blur'}
                    ],
                    totalCount: [
                        {required: true, message: '请输入单品总数', trigger: 'blur'}
                    ],
                    // cartonsGoodsOriginalPrice: [
                    //     {required: true, message: '请输入商品原价', trigger: 'blur'}
                    // ],
                    cartonsGoodsPrice: [
                        {required: true, message: '请输入商品价格', trigger: 'blur'}
                    ],
                    goodsCover:[
                        {required: true, message: '请上传物品封面', trigger: 'blur'}
                    ]
                },
            }
        },
        methods:{
            resetForm(formName) {
                this.$refs[formName].resetFields();
                this.dialogVisible = false
                this.editForm = {}
                this.fileList=[];
                this.parameterList=[]
                this.totalCountdisabled=false
            },
            handleClose() {
                this.resetForm('editForm')
            },
            change(e) {
                this.$forceUpdate()
            },

            getImgList(url,add) {
                if (add==1){
                    this.editForm.goodsCover=url
                }else if (add==0){
                    this.editForm.goodsCover='';
                }
            },
            getParameterList(){
                this.$axios.post("/admin/parameter/getAllParameter").then(res => {
                    this.parameterList = res.data
                })
            },
            onChangeStripe(e){
                var judge=false;
                var list=this.cartonsList
                if (e){
                    list.forEach((item, index)=> {
                        //item 就是当日按循环到的对象
                        //index是循环的索引，从0开始
                        if (item.cartonsId==e){
                            if (item.cartonsType==='Z'){
                                judge=true;
                            }
                        }
                    })
                }
                if (judge){
                    this.totalCountdisabled=true;
                    this.editForm.totalCount=1
                }else {
                    this.totalCountdisabled=false;
                }
            },
            init(id,storeGoodsStatus,cartonsGoodsId){
                this.dialogVisible=true;
                this.id=id;
                this.storeGoodsStatus=storeGoodsStatus
                this.editForm.totalCount=1
                if (storeGoodsStatus!=''&&storeGoodsStatus!=null&&storeGoodsStatus!=undefined&&storeGoodsStatus==1){
                    this.editForm.status=1
                }else {
                    this.editForm.status=0
                }
                if (cartonsGoodsId){
                    this.$axios.post("/admin/singleStoreGoods/getCartonsGoodsDetails",{cartonsGoodsId:cartonsGoodsId}).then(res => {
                        this.editForm = res.data
                        var filess={url:res.data.goodsCover}
                        this.fileList.push(filess)
                    })
                }
            },
            submitForm(formName) {
                this.$refs[formName].validate((valid) => {
                    this.editForm.storeGoodsId=this.storeGoodsId
                    if (valid) {
                        if (this.storeGoodsStatus==1&&(this.editForm.storeGoodsPresellPrice==''||this.editForm.storeGoodsPresellPrice==undefined)){
                            this.$message({
                                showClose: true,
                                message:'请填写商品定金',
                                type: 'error',
                            });
                            return ;
                        }
                        if (this.storeGoodsStatus==1&&(this.editForm.preSaleStartTime==''||this.editForm.preSaleStartTime==undefined)){
                            this.$message({
                                showClose: true,
                                message:'请填写商品预售开始时间',
                                type: 'error',
                            });
                            return ;
                        }
                        if (this.storeGoodsStatus==1&&(this.editForm.preSaleEndTime==''||this.editForm.preSaleEndTime==undefined)){
                            this.$message({
                                showClose: true,
                                message:'请填写商品预售截止时间',
                                type: 'error',
                            });
                            return ;
                        }
                        '/admin/singleStoreGoods/'
                        this.$axios.post('/admin/singleStoreGoods/'+ (this.editForm.cartonsGoodsId?'updateCartonsGoodsDetails' : 'addSingleStoreGoodsRole') , this.editForm).then(res => {
                                this.$message({
                                    showClose: true,
                                    message: '恭喜你，操作成功',
                                    type: 'success',
                                    onClose:() => {
                                        this.$emit('refreshDataList')
                                    }
                                });
                                this.dialogVisible = false
                                this.resetForm(formName)
                            })
                    } else {
                        return false;
                    }
                });
            },
        }
    }
</script>

<style scoped>
.el-select .el-input {
    width: 100%;
  }

  .input-with-select .el-input-group__prepend {
    background-color: #fff;
  }
</style>
